import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class ContactDuplicatePageController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.contactModel = this.injector.get('Contact');
        this.stateParams = this.injector.get('$stateParams');
        this.sweetAlert = this.injector.get('SweetAlert');
        this.locale = this.injector.get('locale');
        this.state = this.injector.get('$state');

        this.model = null;
        this.duplicates = [];
        this.fields = {};
        this.data = [];

        this.contactModel
            .getDuplicate(this.stateParams.id)
            .then((response) => {
                this.model = response;
                this.duplicates = response.duplicates.data;
                delete this.model.duplicates;
                this._setupGrid();
            });

        this.contactModel.getMergeableFields()
            .then((response) => {
                this.fields = response;
            });

        this.columns = [
            {field: 'label', name: ''},
            {field: 'final', name: 'Final'}
        ];
    }

    _setupGrid() {
        const data = [];
        _.forEach(this.fields, (field) => {
            const row = {
                edited: false,
                field: field.slug,
                label: field.name,
                type: field.type,
                titleMap: field.titleMap,
                final: this.model[field.slug]
            };

            _.forEach(this.duplicates, (record, index) => {
                row['duplicate_' + index] = record[field.slug];
                if (_.isUndefined(this.selected[field.slug]) && this.model[field.slug] === record[field.slug]) {
                    this.selected[field.slug] = 'duplicate_' + index;
                }
            });
            data.push(row);
        });

        for (let i = 0; i < this.duplicates.length; i++) {
            this.columns.push({
                field: 'duplicate_' + i,
                name: 'Contact ' + (i + 1)
            });
        }
        this.data = data
    }

    selectValue(row, col) {
        if (col.field === 'label') return;


        if (row[col.field] === 'true') {
            row[col.field] = true;
        } else if (row[col.field] === 'false') {
            row[col.field] = false;
        }

        if (col.field === 'final') {
            this.model[row.field] = row['final'] = row[col.field];
            row['edited'] = true;
            this.selected[row.field] = col.field;
        } else {
            this.model[row.field] = row['final'] = row[col.field];
            row['edited'] = false;
            this.selected[row.field] = col.field;
        }
    }

    selectRecord(col) {
        if (col.field === 'final' || col.field === 'label') return;

        _.forEach(this.data, (row) => {
            this.selectValue(row, col);
        });
    }

    notDuplicate(col) {
        const model = this.duplicates[col.field.replace('duplicate_', '')];
        this.contactModel
            .one(model.id)
            .customPUT({duplicate: false})
            .then(() => {
            })
    }

    saveAndArchive() {
        this.model.unmerged_flag = false;
        return this.model.save()
            .then((model) => {
                model.one('merge')
                    .post()
                    .then(() => {
                        this.sweetAlert.swal(
                            this.locale.getString('contacts.contact_saved'),
                            this.locale.getString('contacts.contact_archive_successful'),
                            'success'
                        );
                        this.state.go('app.contacts.duplicates');
                    })
                    .catch((response) => {
                        this.sweetAlert.swal(
                            this.locale.getString('sweetalerts.saving_unsuccessful'),
                            response.data.message,
                            'error'
                        );
                    });
            });
    }

    diffValues(row) {
        const diff = _.filter(this.columns, col => {
            if (col.field.contains('duplicate')) {
                return row[col.field] !== row.final;
            }
        });

        return diff.length;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/duplicate.js